<template>
  <div>
    <v-btn
      class="audio-button"
      tile
      outlined
      elevation="0"
      color="primary"
      :loading="!canPlay"
      :disabled="!canPlay"
      :small="$vuetify.breakpoint.md || $vuetify.breakpoint.sm"
      @click="!isPlaying ? playAudio() : stopAudio()"
    >
      <ekitabu-icon class="mr-2">
        {{ !isPlaying ? "mdi-play" : "mdi-pause" }}
      </ekitabu-icon>
      {{ $t("common.preview") }}
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    audioUrl: {
      type: String,
      required: true,
    },
  },
  data: () => {
    return {
      audio: null,
      canPlay: false,
      isPlaying: false,
    };
  },
  watch: {
    audio() {
      if (this.audio && !this.audio.error) {
        this.canPlay = true;
      }
    }
  },
  mounted() {
    this.audio = new Audio(this.audioUrl);
    this.onPlay = () => { this.isPlaying = true; };
    this.onPause = () => { this.isPlaying = false; };
    this.audio.addEventListener("play", this.onPlay);
    this.audio.addEventListener("pause", this.onPause);
  },
  beforeDestroy() {
    this.stopAudio();
    this.audio.removeEventListener("play", this.onPlay);
    this.audio.removeEventListener("pause", this.onPause);
    this.audio = null;
  },
  methods: {
    playAudio() {
      if (this.audio) {
        this.audio.play();
      }
    },
    stopAudio() {
      if (this.audio) {
        this.audio.pause();
      }
    },
  },
};
</script>
